var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item-default"},[_vm._v(" "+_vm._s(_vm.item.nome)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }